const NoList: React.FC = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-[var(--spacing-2xl)]">
      <img src="/imgweb/etc/friends_nolist.svg" className="w-3/5" alt="no list" />
      <span className="typography-body-sm text-base-txt-secondary">{brsc.matching_friends_nolist}</span>
    </div>
  );
};

export default NoList;
